module.exports = __webpack_public_path__ + "static/media/community-icon.b98dca9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/community-icon.svg
// module id = 464
// module chunks = 0